/* Kompakter Warenkorb nur bei Platzmangel (Katha Rosa, 04.10.2026)
   Misst im normalen Layout, wie viel Höhe zwischen Kopf/Versandbalken und Fußbereich
   für die Artikel bleibt. Unter MIN_FREI px bekommt <cart-drawer> die Klasse
   warenkorb-kompakt (Regeln in warenkorb-kompakt.css). Reicht selbst das nicht
   (sehr kleines Handy), zusätzlich warenkorb-scrollt: dann scrollt der ganze Drawer.
   Nur auf Handy-Breite (< 750 px); Tablet und Desktop bleiben immer unverändert. */
(() => {
  const MIN_FREI = 240;
  const MIN_FREI_KOMPAKT = 120;
  const HANDY = window.matchMedia('(max-width: 749px)');

  const freieHoehe = (inner) => {
    const hoehe = (selector) => inner.querySelector(selector)?.offsetHeight || 0;
    return (
      inner.clientHeight -
      hoehe('.drawer__header') -
      hoehe(':scope > .versand-info--cart') -
      hoehe('.drawer__footer')
    );
  };

  const pruefen = () => {
    const drawer = document.querySelector('cart-drawer');
    const inner = drawer?.querySelector('.drawer__inner');
    if (!drawer || !inner) return;
    drawer.classList.remove('warenkorb-kompakt', 'warenkorb-scrollt');
    if (drawer.classList.contains('is-empty') || !HANDY.matches) return;
    if (freieHoehe(inner) >= MIN_FREI) return;
    drawer.classList.add('warenkorb-kompakt');
    if (freieHoehe(inner) < MIN_FREI_KOMPAKT) drawer.classList.add('warenkorb-scrollt');
  };

  let geplant = false;
  const planen = () => {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(() => {
      geplant = false;
      pruefen();
      beobachteFuss();
    });
  };

  // Express-Buttons laden verzögert und ändern dabei nur die Höhe des Fußbereichs.
  const groesse = new ResizeObserver(planen);
  let fuss = null;
  const beobachteFuss = () => {
    const neu = document.querySelector('cart-drawer .drawer__footer');
    if (neu === fuss) return;
    if (fuss) groesse.unobserve(fuss);
    fuss = neu;
    if (fuss) groesse.observe(fuss);
  };

  const start = () => {
    const container = document.getElementById('CartDrawer');
    if (!container) return;
    // Dawn ersetzt den Inhalt von #CartDrawer nach jeder Änderung am Warenkorb.
    new MutationObserver(planen).observe(container, { childList: true, subtree: true });
    window.addEventListener('resize', planen);
    window.visualViewport?.addEventListener('resize', planen);
    planen();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
